import { locationsType } from '@components/Items/types'
import useFilter from '@components/Items/utils/hooks/useFilter'
import _isArray from 'lodash/isArray'
import Pill from '@components/Items/Filters/Active/Pill'
import { QUERY_KEYS } from '@components/Items/utils/functions'

const getLabelById = (states: locationsType, id: number) => {
  for (const state in states) {
    const labels = states[state]
    if (id in labels) {
      return labels[id]
    }
  }
  return 'unknown'
}

type activeListType = { label: string; value: string | string[] }[]

type combineStateType = (
  locationList: locationsType,
  locationQuery: string | string[]
) => activeListType

const combineState: combineStateType = (
  locationList: locationsType,
  locationQuery: string | string[]
) => {
  const activeList: activeListType = []
  Object.entries(locationList).forEach(([key, cities]) => {
    let hasAllActiveCities = true
    const activeCityList: { label: string; value: string }[] = []

    Object.entries(cities).forEach(([key, label]) => {
      locationQuery.includes(key)
        ? activeCityList.push({ label, value: key })
        : (hasAllActiveCities = false)
    })

    hasAllActiveCities
      ? activeList.push({
          label: key,
          value: activeCityList.map(({ value }) => value),
        })
      : activeList.push(...activeCityList)
  })

  return activeList
}

const Locations = () => {
  const { locationList, locationQuery, updateQuery } = useFilter()
  if (!locationQuery) return <></>

  if (_isArray(locationQuery))
    return (
      <>
        {combineState(locationList, locationQuery).map(
          ({ label, value }: { label: string; value: string[] | string }) => (
            <Pill
              key={`pill-location-${label}`}
              label={label}
              onClick={() => updateQuery(QUERY_KEYS.LOCATIONS, value, true)}
            />
          )
        )}
      </>
    )

  return (
    <Pill
      label={getLabelById(locationList, Number(locationQuery))}
      onClick={() => updateQuery(QUERY_KEYS.LOCATIONS, locationQuery, true)}
    />
  )
}

export default Locations
